import CrmServiceCollection from "@/collections/CrmServiceCollection"
import CustomerGrowerModel from "@/models/crm/CustomerGrowerModel"

export default class CustomerGrowerCollection extends CrmServiceCollection {
  model() {
    return CustomerGrowerModel
  }
}